import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import safetyLimitServices from "app/services/automations/safety-limit-services";
import SafetyLimitEditor from "./SafetyLimitEditor";
import { SafetyLimitCardDetails, SafetyLimitCardSummary, safetyLimitStatusChip, safetyLimitSubtitle } from "./SafetyLimitSummary";

// Límites de seguridad (SafetyLimit en el backend).
const safetyLimitType = {
    key: "safety_limit",
    label: "Límite de seguridad",
    pickerTitle: "Proteger una salida con un límite",
    pickerDescription: "Si una medición pasa un valor (por ejemplo, la temperatura sobre 30 °C), deja una o más salidas en su estado seguro y nadie puede encenderlas hasta que vuelva a la normalidad.",
    icon: ShieldOutlinedIcon,
    order: 30,
    Editor: SafetyLimitEditor,
    CardSummary: SafetyLimitCardSummary,
    CardDetails: SafetyLimitCardDetails,
    subtitle: safetyLimitSubtitle,
    statusChip: safetyLimitStatusChip,
    setEnabled: (item, enabled) => safetyLimitServices.updateSafetyLimit(item.id, { enabled }),
    remove: (item) => safetyLimitServices.deleteSafetyLimit(item.id),
    confirmRemove: (item) => `¿Eliminar el límite "${item.name}"? Sus salidas dejan de estar protegidas.`,
    canDuplicate: true,
    draftTypes: ["safety_limit"],
    draftTarget: (message) => {
        const payload = message?.draft_payload || {};
        return payload.mode === "update" ? (payload.target_id || payload.safety_limit?.id || null) : null;
    },
};

export default safetyLimitType;
